import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const securityFeatures = [
  {
    icon: 'Shield',
    title: 'Защищенное соединение',
    description: 'SSL-шифрование данных'
  },
  {
    icon: 'Lock',
    title: 'Конфиденциальность',
    description: 'GDPR совместимость'
  },
  {
    icon: 'CheckCircle',
    title: 'Проверенная платформа',
    description: '10,000+ активных пользователей'
  }];


  const testimonials = [
  {
    name: 'Алексей Навальный',
    role: 'Политический активист',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1611f7920-1763295260796.png",
    avatarAlt: 'Professional headshot of middle-aged man with short brown hair wearing dark blue shirt',
    quote: 'Платформа где мой голос звучит без цензуры и алгоритмов'
  },
  {
    name: 'Мария Петрова',
    role: 'Подкастер',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1497cd398-1763294526444.png",
    avatarAlt: 'Professional portrait of young woman with long blonde hair in casual white top',
    quote: 'Наконец-то нашла место для аутентичного общения с аудиторией'
  }];


  return (
    <div className="trust-signals space-y-8">
      <div className="security-features grid grid-cols-1 gap-4">
        {securityFeatures?.map((feature, index) =>
        <div
          key={index}
          className="security-feature flex items-start gap-3 p-4 bg-background/50 rounded-lg border border-border/50">

            <div className="feature-icon w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="feature-content">
              <h4 className="text-sm font-heading font-semibold text-foreground mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          </div>
        )}
      </div>
      <div className="testimonials-section">
        <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
          Что говорят создатели
        </h3>
        <div className="testimonials space-y-4">
          {testimonials?.map((testimonial, index) =>
          <div
            key={index}
            className="testimonial p-4 bg-background/50 rounded-lg border border-border/50">

              <div className="testimonial-header flex items-center gap-3 mb-3">
                <div className="testimonial-avatar w-10 h-10 rounded-full overflow-hidden bg-muted flex-shrink-0">
                  <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="testimonial-info">
                  <h4 className="text-sm font-heading font-semibold text-foreground">
                    {testimonial?.name}
                  </h4>
                  <p className="text-xs text-muted-foreground">
                    {testimonial?.role}
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground/80 italic">
                "{testimonial?.quote}"
              </p>
            </div>
          )}
        </div>
      </div>
    </div>);

};

export default TrustSignals;